import { Node, mergeAttributes } from '@tiptap/core';
/**
 * This extension allows you to create paragraphs.
 * @see https://www.tiptap.dev/api/nodes/paragraph
 */

var Paragraph = Node.create({
  name: 'paragraph',
  priority: 1000,
  addOptions: function addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: 'block',
  content: 'inline*',
  parseHTML: function parseHTML() {
    return [{
      tag: 'p'
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['p', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this = this;

    return {
      setParagraph: function setParagraph() {
        return function (_ref2) {
          var commands = _ref2.commands;
          return commands.setNode(_this.name);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this2 = this;

    return {
      'Mod-Alt-0': function ModAlt0() {
        return _this2.editor.commands.setParagraph();
      }
    };
  }
});
export { Paragraph, Paragraph as default };